export default "__VITE_ASSET__DyZ8GTqc__"